/**
 * Blend independent apartment / house CHF/m² assumptions into one GDV driver.
 * Mirrors backend calculation_engine.resolve_sale_price_per_sqm.
 */
export function resolveSalePricePerSqm({
  pricePerSqm = 0,
  apartmentPricePerSqm = 0,
  housePricePerSqm = 0,
  apartmentSaleableShare = 0.5,
} = {}) {
  const apt = Number(apartmentPricePerSqm) > 0 ? Number(apartmentPricePerSqm) : 0;
  const house = Number(housePricePerSqm) > 0 ? Number(housePricePerSqm) : 0;
  let share = Number(apartmentSaleableShare);
  if (!Number.isFinite(share)) share = 0.5;
  share = Math.min(1, Math.max(0, share));

  if (apt > 0 && house > 0) return apt * share + house * (1 - share);
  if (apt > 0) return apt;
  if (house > 0) return house;
  const fallback = Number(pricePerSqm);
  return Number.isFinite(fallback) && fallback > 0 ? fallback : 0;
}

export function withSyncedSalePrice(inputsPatch, base = {}) {
  const merged = { ...base, ...inputsPatch };
  const blended = Math.round(resolveSalePricePerSqm(merged));
  return { ...merged, pricePerSqm: blended > 0 ? blended : (merged.pricePerSqm || 0) };
}
